export const PANEL_COMPANY_MANAGEMENT = "company_management";
export const PANEL_CA_SETTINGS = "ca_settings";
export const PANEL_USER_MANAGEMENT = "user_management";
export const PANEL_RECYCLE_BIN = "recycle_bin";
export const PANEL_DISCLOSURES = "disclosures";
export const PANEL_EDITOR_CONTROL = [
  PANEL_CA_SETTINGS,
  PANEL_USER_MANAGEMENT,
  PANEL_RECYCLE_BIN,
  PANEL_DISCLOSURES
];

export const TAX_COMPUTATION = "tax_computation";

export const SYSTEM_CONTROL = [
  PANEL_CA_SETTINGS,
  PANEL_USER_MANAGEMENT,
  PANEL_RECYCLE_BIN,
  PANEL_DISCLOSURES,
  PANEL_COMPANY_MANAGEMENT,
  TAX_COMPUTATION
];

export const MAIN_COMPUTATION = "main_computation";
export const DETAIL_PL = "detail_pl";
export const SCHEDULE_MENU = "schedules_list";

export const TAX_COMPUTATION_MENU = "tax_computation_menu";

export const PL_SCHEDULES = "pl_schedules";
export const BREAKDOWN_SCHEDULES = "breakdown_schedules";
export const DUMMY_SCHEDULES = "dummy_schedules";
export const FOREIGN_INCOME_TRACKER_SCHEDULES =
  "foreign_income_tracker_schedules";
export const CA_SCHEDULES = "ca_schedules";
export const PLS_FURTHER_DEDUCTION = "further_deduction_sch";

export const SETTING_PROFILE = "profile";
export const SETTING_ORGANIZATION = "organization";
export const SETTING_CHANGE_PASSWORD = "change_password";
export const SETTING_PREFERENCES = "preferences";
export const SETTING_BILLING = "billing";
